/*
 * 戒导航 · 内容审核 —— 前台扩展声明
 *
 * 设计依据：doc/发帖与配图内容审核设计方案.md（v1.0）§11.4「通知三件套」。
 *
 * 这里注册两样东西，**缺一不可**：
 *
 * ── ① 前台模型 contentReviews（Store）────────────────────────────────────────
 *   ★ 为什么必须注册（漏了它 → 通知面板一片空白，且不报错）：
 *     本模块的通知 subject 是「内容审核留痕记录行」（见
 *     JieDH\ContentReview\Notify\ContentViolationBlueprint::getSubject()），
 *     通知接口的关系是 relationships.subject = { type: 'contentReviews', id: 'N' }。
 *     而 Flarum 前端的本地仓库 app.store 只接收**已注册的 type**：
 *       vendor/flarum/core/js/src/common/Store.ts → pushObject()
 *         if (!this.models[data.type]) { ... return null; }   // ← 未注册：资源被静默丢弃
 *     未注册 ⇒ notification.subject() 得到 undefined ⇒
 *       vendor/flarum/core/js/src/forum/components/NotificationList.js:82
 *         if (typeof subject === 'undefined') return;         // ← 整条通知被丢弃
 *     type 名 'contentReviews' 必须与后端
 *     JieDH\ContentReview\Api\Resource\ContentReviewResource::type() 完全一致。
 *     （与本项目 packages/avatar-guard 的 secondReviews 完全同源，只是换名避免冲突。）
 *
 * ── ② 通知渲染组件（Notification）────────────────────────────────────────────
 *   核心的渲染逻辑是（vendor/flarum/core/js/src/forum/components/NotificationType.tsx）：
 *       const C = app.notificationComponents[notification.contentType()];
 *       return C ? <C notification={...} /> : null;
 *   取不到组件就**静默 return null**（不报错、不显示）—— 新通知类型必须自己注册。
 *   第一个参数（通知类型标识）必须与后端
 *   JieDH\ContentReview\Notify\ContentViolationBlueprint::getType() 的返回值完全一致，
 *   即 **jiedhContentReviewViolation**（★ 不可与 avatar-guard 的 jiedhContentViolation 重名）。
 *
 * 注册写法照抄官方与本项目 packages/avatar-guard/js/src/forum/extend.ts。
 */
import Extend from 'flarum/common/extenders';
import ContentReview from './models/ContentReview';
import ContentReviewViolationNotification from './components/ContentReviewViolationNotification';
export default [
// ① 内容审核留痕记录模型：让通知接口的 subject 关系能被前端 store 接收
new Extend.Store().add('contentReviews', ContentReview),
// ② 内容违规处置通知卡片（通过留痕抽查中被驳回后发给用户的站内消息）
new Extend.Notification().add('jiedhContentReviewViolation', ContentReviewViolationNotification)];